export function parseVideoUrl(url) {
  if (!url) return null;
  url = url.trim();
  let m;
  // YouTube
  m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/)|youtu\.be\/)([A-Za-z0-9_-]{6,20})/);
  if (m) return { provider: "youtube", id: m[1], embed: `https://www.youtube-nocookie.com/embed/${m[1]}?rel=0` };
  // Vimeo
  m = url.match(/vimeo\.com\/(?:video\/)?(\d{6,12})/);
  if (m) return { provider: "vimeo", id: m[1], embed: `https://player.vimeo.com/video/${m[1]}` };
  return null;
}
